import React from 'react';
import { RectangleSkeletonContainer } from "./RectangleSkeleton.styles";
import { jsx as _jsx } from "react/jsx-runtime";
const RectangleSkeleton = props => {
  const {
    width,
    height = 100
  } = props;
  return /*#__PURE__*/_jsx(RectangleSkeletonContainer, {
    width: width,
    height: height
  });
};
export { RectangleSkeleton };